interface Environment {
  production: boolean;
  baseUrl: string;
  features: string[];
  surveyApiHost: string;
  apiHost: string;
  facebookAppId: string | null;
  intercomAppId: string | null;
  googleAnalyticsId: string | null;
  signupUrl: string;
  sentryUrl: string | null;
  showNgxsLog: boolean;
  mapTileProviderUrl: string;
  mapLabelTileProviderUrl: string;
  mapTileProviderAttribution: string;
  matomoUrl: string | null;
  matomoSiteId: string | null;
}

const fallback: Environment = {
  production: false,
  baseUrl: "",
  features: [],
  surveyApiHost: "",
  apiHost: "",
  facebookAppId: null,
  intercomAppId: null,
  googleAnalyticsId: null,
  signupUrl: "",
  sentryUrl: null,
  showNgxsLog: false,
  mapTileProviderUrl: "http://tile.stamen.com/toner-lite/{z}/{x}/{y}.png",
  mapLabelTileProviderUrl:
    "http://tile.stamen.com/toner-labels/{z}/{x}/{y}.png",
  mapTileProviderAttribution:
    '&copy; <a href="http://maps.stamen.com">Stamen Design</a>',
  matomoUrl: null,
  matomoSiteId: null,
};

const getRuntimeConfig = (): Partial<Environment> => {
  if (typeof window !== "undefined" && window["env"]) {
    return window["env"];
  }
  return {};
};

export const environment: Environment = {
  ...fallback,
  ...getRuntimeConfig(),
};
